import { SiteLayout } from '../../components/site/SiteLayout';
import { PillLink } from '../../components/site/Pill';
import { INTERIORS, PILLARS, STATS, TEAM } from '../../lib/site';

export default function SiteAbout() {
  return (
    <SiteLayout>
      <section className="bg-cream">
        <div className="site-narrow py-20 lg:py-32">
          <p className="eyebrow">About Lotus Living</p>
          <h1 className="display mt-4 max-w-[980px] text-[44px] text-ink-900 sm:text-[60px] lg:text-[80px]">Building high-quality homes <em>just for renters</em></h1>
          <div className="mt-10 grid gap-10 md:grid-cols-2 md:gap-20">
            <p className="text-[18px] leading-[1.7] text-ink-700">Lotus Living is a boutique British property developer with deep roots in the inspiring city of London. We don't just build apartments. We build homes.</p>
            <p className="text-[16px] leading-[1.75] text-ink-600">We're proud to be a wholly family-owned business, dedicated to building modern, comfortable, stylish and sustainable build to rent properties. Every home is finished with the touches that make people feel at ease from the day they move in — and looked after by us for as long as they stay.</p>
          </div>
        </div>
      </section>

      <section className="site-narrow grid items-center gap-14 py-24 md:grid-cols-2 lg:gap-24 lg:py-36">
        <div className="order-2 md:order-1">
          <p className="eyebrow">Our founder</p>
          <h2 className="display mt-4 text-[36px] text-ink-900 sm:text-[48px]">Rajiv Nehru, <em>CEO</em></h2>
          <div className="mt-6 space-y-5 text-[16px] leading-[1.75] text-ink-600">
            <p>Rajiv is an accomplished property professional with more than two decades of experience across property management, contracting and development.</p>
            <p>He founded Lotus Living and has grown it into a Build-to-Rent platform of around 1,000 homes with a gross development value of £300 million. His ambition is a 10,000-home portfolio worth £3.5 billion — built on relationships, and on creating communities people are proud to come home to.</p>
          </div>
          <dl className="mt-10 grid grid-cols-2 gap-8">
            {STATS.map((s) => (
              <div key={s.label}><dt className="display text-[40px] text-ink-900 sm:text-[48px]">{s.value}</dt><dd className="mt-1 text-[13px] text-ink-500">{s.label}</dd></div>
            ))}
          </dl>
        </div>
        <div className="order-1 md:order-2"><img src={INTERIORS.welcomeHamper} alt="Welcome hamper at Drake House" className="aspect-[4/5] w-full rounded-[10px] object-cover" /></div>
      </section>

      <section className="border-t border-ink-100">
        <div className="site-narrow py-24 lg:py-36">
          <h2 className="display max-w-[760px] text-[40px] text-ink-900 sm:text-[52px] lg:text-[64px]">We don't just build apartments. <em>We build homes.</em></h2>
          <div className="mt-14 grid gap-x-16 gap-y-12 md:grid-cols-2">
            {PILLARS.map((p, i) => (
              <div key={p.title} className="border-t border-ink-200 pt-6">
                <div className="text-[11px] font-semibold uppercase tracking-[0.2em] text-bronze-500">0{i + 1}</div>
                <h3 className="display mt-3 text-[28px] text-ink-900">{p.title}</h3>
                <p className="mt-3 text-[15px] leading-[1.75] text-ink-600">{p.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="relative overflow-hidden bg-ink-900 text-white">
        <img src={INTERIORS.livingArea} alt="" className="absolute inset-0 h-full w-full object-cover opacity-40" loading="lazy" />
        <div className="site-narrow relative z-10 grid gap-12 py-24 md:grid-cols-2 lg:py-36">
          <div>
            <p className="eyebrow !text-bronze-300">Build to Rent</p>
            <h2 className="display mt-4 text-[36px] sm:text-[48px]">Grow, Live and Thrive</h2>
          </div>
          <div className="space-y-5 text-[16px] leading-[1.75] text-white/80">
            <p>Whether it's choosing Lotus Living for your first rental property or your 10th, you'll find our build to rent communities warm, welcoming and inclusive.</p>
            <p>We're more than just a landlord, we're a community builder, committed to creating homes where residents can live, grow, and thrive.</p>
            <PillLink to="/living-with-us" variant="white" className="!mt-8">Living With Us</PillLink>
          </div>
        </div>
      </section>

      <section className="site-narrow py-24 lg:py-36">
        <p className="eyebrow">The team</p>
        <h2 className="display mt-4 text-[40px] text-ink-900 sm:text-[52px]">A friendly, <em>approachable</em> team</h2>
        <ul className="mt-12 grid gap-x-8 gap-y-8 sm:grid-cols-2 lg:grid-cols-4">
          {TEAM.map(([name, role]) => (
            <li key={name} className="flex items-center gap-4">
              <span className="grid h-12 w-12 shrink-0 place-items-center rounded-full bg-bronze-100 font-display text-[18px] text-bronze-700">{name.split(' ').map((n) => n[0]).join('')}</span>
              <span><span className="block text-[15px] font-medium text-ink-900">{name}</span><span className="block text-[13px] text-ink-500">{role}</span></span>
            </li>
          ))}
        </ul>
      </section>
    </SiteLayout>
  );
}
